module.exports = __webpack_public_path__ + "img/temperature_green.8f89f867.svg";